import React from "react"
import { Link } from "gatsby"
import "./menu.css"

import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap"

const HorizontalMenu = () => {
  return (
    <>
      <div className="hmenu-wrapper">
        <div>
          <div className="row justify-content-center">
            <div
              className="d-flex flex-row justify-content-between"
              style={{ width: "max-content" }}
            >
              <Link
                className="nav-menu mx-4 font-weight-bold"
                aria-label="link"
                to="/shop"
              >
                SHOP
              </Link>
              <Link
                className="nav-menu mx-4 font-weight-bold"
                aria-label="link"
                to="/inside-fluo/"
              >
                ADVOCACY
              </Link>
              {/* <Link
                className="nav-menu mx-2 font-weight-bold"
                aria-label="link"
                to="/stories/"
              >
                STORIES
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HorizontalMenu
